@keyframes top-bar-fade-in {
  from {
    background-color: rgba(255, 255, 255, 0);
    border-bottom-color: rgba(226, 232, 240, 0);
  }
  to {
    background-color: rgba(255, 255, 255, 1);
    border-bottom-color: rgba(226, 232, 240, 1);
  }
}

@keyframes logo-fade-in {
  from {
    opacity: 0;
    pointer-events: none;
  }
  to {
    opacity: 1;
    pointer-events: auto;
  }
}

.fixed-mobile-top-bar {
  border-bottom: 1px solid rgba(226, 232, 240, 0);
  animation: top-bar-fade-in linear both;
  animation-timeline: scroll();
  animation-range: 150px 280px;
}

.fixed-mobile-top-bar__logo {
  opacity: 0;
  pointer-events: none;
  animation: logo-fade-in linear both;
  animation-timeline: scroll();
  animation-range: 150px 280px;
}

.fixed-mobile-top-bar--compact {
  animation-range: 0px 50px;
}

.fixed-mobile-top-bar--compact .fixed-mobile-top-bar__logo {
  animation-range: 0px 50px;
}

.fixed-mobile-top-bar--solid {
  background-color: rgba(255, 255, 255, 1);
  border-bottom-color: rgba(226, 232, 240, 1);
  animation: none;
}

.fixed-mobile-top-bar--solid .fixed-mobile-top-bar__logo {
  opacity: 1;
  pointer-events: auto;
  animation: none;
}
